import { get, post, path_version } from '@/httpRequest/http'
const { VUE_APP_UC } = process.env
import { getBaseUrl } from '@/utils'

const baseUrl = getBaseUrl(VUE_APP_UC)

/**
 * 合规出入金相关接口
 */

/**
 * 客户提交资料
 * @param {Object} data 提交数据
 * @param {Object} data.employmentInfo 学历及工作情况
 * @param {Object} data.financialInfo 财务资料
 * @param {Object} data.additionalInfo 新增资料
 * @param {string} data.complianceSignatureOssId 合规重检签名OSS ID
 */
export const ComplianceAuditDetailSubmit = data => {
    return post(baseUrl + `/uc/${path_version}/ComplianceAuditDetailSubmit`, {
        data,
        // 不设置 encTag 和 isTrade，使用默认的登录加密
    })
}

/**
 * 查询客户的审核状态
 * @returns {Promise} 返回审核状态信息
 */
export const ComplianceAuditStatus = () => {
    return get(baseUrl + `/uc/${path_version}/ComplianceAuditStatus`, {
        showFreezeToast: false,
    })
}

/**
 * 获取OSS上传ID（用于签名文件上传）
 * 这个接口需要根据实际情况调整，可能需要调用文件上传相关的接口
 */
export const getOssUploadId = () => {
    // 这里可能需要调用文件上传初始化接口
    // 具体实现需要根据实际的OSS上传流程来定义
    return Promise.resolve({
        uploadId: 'temp_upload_id_' + Date.now(),
        ossId: null
    })
}
